import React, { useEffect, useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { COPY } from './copy';

// Enter sends, Shift+Enter adds a line. `draft` lets other parts of the page
// ("Ask <coach> about this") put text in the box.
export default function Composer({ coachName, onSend, disabled, statusText, draft, onDraftConsumed, placeholder }) {
  const prompt = placeholder || COPY.composerPlaceholder(coachName);
  const [value, setValue] = useState('');
  const [focused, setFocused] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (draft) {
      setValue(draft);
      if (ref.current) ref.current.focus();
      if (onDraftConsumed) onDraftConsumed();
    }
  }, [draft]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 160)}px`;
  }, [value]);

  const submit = () => {
    const text = value.trim();
    if (!text || disabled) return;
    onSend(text);
    setValue('');
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent?.isComposing) {
      event.preventDefault();
      submit();
    }
  };

  const canSend = value.trim().length > 0 && !disabled;

  return (
    <div className="flex flex-col gap-1.5">
      <div
        className={`flex items-end gap-2 bg-muted border rounded-xl py-[5px] pr-[5px] pl-4 min-h-11 ${
          focused ? 'border-succeedo-orange shadow-[0_0_0_3px_hsl(var(--succeedo-orange)/0.2)]' : 'border-border shadow-none'
        }`}
      >
        <label htmlFor="george-composer" className="sr-only">{prompt}</label>
        <textarea
          id="george-composer"
          ref={ref}
          rows={1}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={onKeyDown}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={prompt}
          maxLength={4000}
          className="flex-1 min-w-0 resize-none border-0 outline-none bg-transparent text-[15px] leading-normal py-2 px-0 text-foreground [font-family:inherit]"
        />
        <button
          type="button"
          aria-label="Send"
          onClick={submit}
          disabled={!canSend}
          className="w-9 h-9 rounded-md border-0 bg-orange-cta text-white flex items-center justify-center shrink-0 cursor-pointer disabled:bg-muted-foreground/35 disabled:cursor-default"
        >
          <ArrowUp size={18} />
        </button>
      </div>
      <div className="hidden md:flex justify-between gap-3 font-label text-[10px] text-muted-foreground/80 px-1">
        <span>{COPY.composerHint}</span>
        <span>{statusText}</span>
      </div>
    </div>
  );
}
